import { useNavigate } from "react-router-dom";
import FooterBlock from "../../components/Footer/Footer";
import { useTranslation } from "react-i18next";
import ActionButton from "../../components/Buttons/Action/ActionButton";

const NotFoundPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className={"startBellowNavbar pageBlock"}>
      <h1>404</h1>
      <p>{t('error.notFound')}</p>
      <div className={"button-container"}>
        <ActionButton
          onClick={() => {
            navigate(`/`);
          }}
        >
          {t('common.backToHome')}
        </ActionButton>
      </div>
      <FooterBlock />
    </div>
  );
};

export default NotFoundPage;
